import React, { FC } from "react";
import PropTypes from "prop-types";

import { styleSheet } from "./styles";
import injectSheet from "react-jss";

export interface ILabelProps {
  id?: string;
  htmlFor?: boolean;
  className?: string;
  classes: any;
}

const labelClasses = (props: ILabelProps) => {
    const classList = props.className;
    //Check if classList exists on props
    return classList && classList.length ? props.className : null;
  },
  label: FC<ILabelProps> = props => {
    return (
      <label
        htmlFor={props.htmlFor ? `${props.classes.label}-${props.id}` : null}
        className={labelClasses(props)}
      >
        {props.children}
      </label>
    );
  };

label.propTypes = {
  id: PropTypes.string,
  htmlFor: PropTypes.bool,
  className: PropTypes.string,
  classes: PropTypes.object
};

label.defaultProps = {
  id: "",
  htmlFor: false,
  className: ""
};

export const Label = injectSheet(styleSheet)(label);